import { h, Fragment } from 'preact';
import PropTypes from 'prop-types';

import { IconClose, IconArrowLink } from '../../1-foundation/icons/icons';
import { getClassNames } from '../../../../utils/classnames-utils';
import Cta from '../../2-atoms/cta/cta';

const DEFAULT_CLASSNAMES = '';

const Modal = ({
  onClose,
  modifiers,
  description,
  title,
  iconComponent,
  footerCtaList,
  classNames = DEFAULT_CLASSNAMES,
}) => {
  const IconComponent = iconComponent;

  let cn = getClassNames('c-modal', modifiers);
  if (classNames) {
    cn += ` ${classNames}`;
  }

  return (
    <div className={cn} data-state="active">
      <div className="c-modal__container-ext">
        <div className="c-modal__container-int">
          <div className="c-modal__toolbar">
            <button type="button" className="c-modal__tool c-modal__tool--close" onClick={onClose}>
              <IconClose modifiers={['navigation', 'c-medium-light', 'xsmall', 'close']} />
            </button>
          </div>
          {iconComponent && <Modal.Logo>{IconComponent}</Modal.Logo>}
          <Modal.Wrapper>
            {title && (
              <Modal.Header>
                <h4 className="c-modal__content-title">{title}</h4>
              </Modal.Header>
            )}
            {description && (
              <Modal.Content>
                <p className="c-modal__content-description" dangerouslySetInnerHTML={{ __html: description }} />
              </Modal.Content>
            )}
            {footerCtaList && (
              <Fragment>
                <hr className="c-modal__hr" />
                <Modal.Footer>
                  {footerCtaList.map((cta, i) => (
                    <Cta
                      key={i}
                      modifiers={cta.modifiers}
                      onClick={cta.action}
                      disabled={cta.disabled}
                      append={
                        cta.hasArrow && <IconArrowLink modifiers={['arrow-navigation', 'arrow-link', 'c-primary']} />
                      }
                    >
                      {cta.label}
                    </Cta>
                  ))}
                </Modal.Footer>
              </Fragment>
            )}
          </Modal.Wrapper>
        </div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  onClose: PropTypes.func.isRequired,
  modifiers: PropTypes.array.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  iconComponent: PropTypes.any,
  footerCtaList: PropTypes.array,
  classNames: PropTypes.string,
};

Modal.Wrapper = ({ children }) => <div className="c-modal__content-wrapper">{children}</div>;

Modal.Wrapper.propTypes = {
  children: PropTypes.any,
};

/* eslint-disable react/prop-types */
Modal.Header = ({ children }) => <div className="c-modal__header ">{children}</div>;

Modal.Content = ({ children }) => <div className="c-modal__content">{children}</div>;

Modal.Footer = ({ children }) => <div className="c-modal__footer ">{children}</div>;

Modal.Logo = ({ children }) => <div className="c-modal__icon">{children}</div>;

export default Modal;
